/**
 * @module app.track.printService
 */
class TrackPrintService {
  /**
   * @param {angular.$timeout} $timeout Angular timeout service.
   * @ngInject
   */
  constructor($timeout) {

    /**
     * @private
     */
    this.timeout_ = $timeout;
  }

  /**
   * @export
   */
  printDetailedProfile() {
    //timeout to wait on the refresh of d3
    this.timeout_(function() {
      // Rely on print CSS to only keep the detailed profile.

      // workaround for safari
      const printed = document.execCommand('print', false, null);
      if (!printed) {
        window.print();
      }
    }, 500);
  }

}

export default angular.module('appTrackPrintService', [])
  .service('appTrackPrintService', TrackPrintService);
